import { useState } from 'react';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (motivo: string) => void;
}

export default function RejectionModal({ isOpen, onClose, onConfirm }: Props) {
    const [motivo, setMotivo] = useState('');
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const handleSubmit = () => {
        if (!motivo.trim()) {
            setError('El motivo es obligatorio');
            return;
        }
        onConfirm(motivo);
        setMotivo('');
        setError('');
    };

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 animate-fade-in">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 animate-scale-in">
                <div className="p-6">
                    <div className="flex items-start space-x-4">
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-100">
                            <i className="ri-error-warning-fill text-red-500 text-2xl"></i>
                        </div>
                        <div className="flex-1">
                            <h3 className="text-lg font-bold text-slate-800 mb-2">Rechazar Requisición</h3>
                            <p className="text-sm text-slate-600 mb-4">
                                Por favor ingrese el motivo del rechazo. Esta acción no se puede deshacer.
                            </p>

                            <textarea
                                value={motivo}
                                onChange={(e) => {
                                    setMotivo(e.target.value);
                                    setError('');
                                }}
                                className={`w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 resize-none ${error ? 'border-red-500' : 'border-slate-300'
                                    }`}
                                rows={4}
                                placeholder="Motivo del rechazo..."
                            ></textarea>
                            {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
                        </div>
                    </div>
                </div>

                <div className="bg-slate-50 px-6 py-4 rounded-b-xl flex items-center justify-end space-x-3">
                    <button
                        onClick={() => {
                            setMotivo('');
                            setError('');
                            onClose();
                        }}
                        className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                    >
                        Rechazar
                    </button>
                </div>
            </div>
        </div>
    );
}
